import { UserConfigGetAPI } from "@/features/accountSettings/api/UserConfigAPI";
import type { UserConfigAPIResponse } from "@/features/accountSettings/types/schemas";
import { useEffect } from "react";

interface ConfigGetAPIParams {
  // 設定用のコールバック関数
  onUserSettingsLoaded: (data: UserConfigAPIResponse) => void;
  // 再取得時コールバック実行可否
  enableCallbackOnRefetch?: boolean;
}

/**
 * ユーザー設定を取得するカスタムフック
 * @params
 * - onUserSettingsLoaded 設定用のコールバック関数
 * - enableCallbackOnRefetch 再取得時コールバック実行可否、デフォルトはtrue
 */
export const useUserConfig = ({
  onUserSettingsLoaded,
  enableCallbackOnRefetch = true,
}: ConfigGetAPIParams): void => {
  // ユーザー設定取得
  const userConfig = UserConfigGetAPI();

  useEffect(() => {
    // 再びサーバーからデータを取りに行った時に入力中の値が上書きされてしまう
    // そこで、一度でも入力があったら更新しないようにする
    if (!enableCallbackOnRefetch) {
      return;
    }
    if (userConfig) {
      onUserSettingsLoaded(userConfig);
    }
  }, [userConfig, enableCallbackOnRefetch]);
};
